module.exports = __webpack_public_path__ + "static/btn_WhatsApp-d54feaa726dccbc0b4e90cd25b316885.png";